<input class="checkBoxItem" name="chkBxEachItme" type="checkbox" [checked]="isSelected"
    id="booleanOption" [ngClass]="{'disabled opacity-60': isCheckboxDisabled }"
    [disabled]="isCheckboxDisabled"
    (input)="onClick($event)">